import { style } from "@vanilla-extract/css";
import { surfaceContainerStyles } from "plos/src/components/SurfaceContainer/SurfaceContainer.css";
import { columnStyles } from "plos/src/components/Table/tables.css";
import { vars } from "plos/src/styles/theme.css";

export const explainList = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
  padding: `0 ${vars.space["m"]}`,
});

export const elementExplainItem = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
  overflowY: "auto",
});

export const fixtureContainer = style([
  surfaceContainerStyles,
  { position: "relative", padding: 0 },
]);

export const liveIndicatorBar = style({
  position: "absolute",
  top: "50%",
  insetInlineStart: 0,
  transform: "translateY(-50%)",
  height: "75%",
});

export const tableCaption = style({
  padding: vars.space.xs,
  fontSize: vars.fontSizes.heading.l,
});

export const pointsCol = style([
  columnStyles,
  {
    textAlign: "end",
  },
]);

export const pointsCell = style({
  paddingInlineEnd: vars.space.xs,
  textAlign: "end",
});

export const kickoffDateHeader = style({
  paddingBlockStart: vars.space.m,
  paddingBlockEnd: 0,
  paddingInlineStart: vars.space.m,
  paddingInlineEnd: 0,
  fontSize: vars.fontSizes.heading.m,
});
